import { Children, isValidElement, type ReactNode } from 'react';

import { ButtonGroupItem } from './ButtonGroupItem';

import type { DropdownMenu2OptionItemData } from '../DropdownMenu2';
import type { ButtonGroupItemData } from './types';

export const parseDropdownItems = (
  children: ReactNode,
  startIndex: number,
): DropdownMenu2OptionItemData[] => {
  const items: DropdownMenu2OptionItemData[] = [];
  const childArray = Children.toArray(children);

  // startIndex부터의 children만 파싱
  childArray.slice(startIndex).forEach(child => {
    if (!isValidElement(child)) return;

    if (child.type === ButtonGroupItem) {
      const props = child.props as ButtonGroupItemData;

      items.push({
        ...props.dropdownItemProps,
        onClick: props.onClick,
        disabled: props.disabled,
      });
    }
  });

  return items;
};
